import SEO from "@/components/SEO";

const METHOD_STYLES = {
  GET: "bg-emerald-500/10 text-emerald-400",
  POST: "bg-primary/10 text-primary",
  DELETE: "bg-rose-500/10 text-rose-400",
};

const methodClass = (method) => METHOD_STYLES[method] || "bg-secondary text-muted-foreground";

const ENDPOINTS = [
  { method: "POST", path: "/api/analyze", desc: "Run a full channel analysis.", body: `{ "url": "https://youtube.com/@channel", "force_refresh": false }` },
  { method: "POST", path: "/api/compare", desc: "Compare two channels side by side.", body: `{ "url_a": "...", "url_b": "..." }` },
  { method: "GET", path: "/api/channel/{slug}", desc: "Return a cached analysis by slug (@handle) or channel_id." },
  { method: "GET", path: "/api/rankings?sort=subscribers", desc: "Rankings sorted by metric." },
  { method: "GET", path: "/api/history", desc: "Recent analyses on the platform." },
  { method: "GET", path: "/api/favorites", desc: "List of favorited channels." },
  { method: "POST", path: "/api/favorites", desc: "Save a channel to favorites.", body: `{ "channel_id": "UC...", "title": "..." }` },
  { method: "DELETE", path: "/api/favorites/{channel_id}", desc: "Remove a favorite." },
  { method: "GET", path: "/api/growth/{channel_id}", desc: "Growth history for a channel." },
  { method: "GET", path: "/api/health", desc: "Service health." },
  { method: "GET", path: "/api/sitemap.xml", desc: "Dynamic XML sitemap for indexing." },
];

export default function ApiPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
      <SEO
        title="API Reference"
        description="REST endpoints of the Creator Intelligence Tube platform. Integrate YouTube channel analysis into your own applications."
        path="/api"
      />
      <div className="overline">Reference</div>
      <h1 className="text-5xl font-black tracking-tighter mt-2">API</h1>
      <p className="mt-4 text-muted-foreground">
        REST endpoints exposed by the backend. All paths under <code className="font-mono text-primary">/api</code>.
      </p>
      <div className="mt-10 space-y-3">
        {ENDPOINTS.map((e) => (
          <div key={e.method + e.path} className="card-flat p-5">
            <div className="flex flex-wrap items-center gap-3">
              <span className={`text-xs font-bold font-mono px-2 py-1 rounded ${methodClass(e.method)}`}>
                {e.method}
              </span>
              <code className="font-mono text-sm">{e.path}</code>
            </div>
            <div className="mt-2 text-sm text-muted-foreground">{e.desc}</div>
            {e.body && (
              <pre className="mt-3 p-3 rounded-md bg-secondary/40 border border-border overflow-x-auto text-xs font-mono">{e.body}</pre>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
